import { checkAndCacheAll } from './common'

export async function getBoards (fetchFunction) {
  return checkAndCacheAll('boards', fetchFunction)
}
